<template lang="pug">
  include /mixins
  div
    +b.ds-panel.--space_xl.--space_2xl-xl
      +e.element.--offset_bottom
        +b.ds-caption--size_md.--size_3md-xl.--appearance_center-till-md.--semibold.P {{ _("Приложите согласие пациента, подтверждающее возможность публикации его фото") }}
    +b.g-row.--space_lg.--appearance_spaced
      +b.g-cell.g-cols--12.--6-md
        result-loader(
          :width="188"
          :height="240"
          :ratio="7/9"
          :rate="2"
          :post-resource="isEquipment ? $options.EquipmentResultPatientConsentCreate : $options.ResultPatientConsentCreate",
          :titles="loaderTitles"
          :simple-view="true"
          :need-crop="false"
          :uploaded-file="form.localFiles.patient_consent_obj"
          filekey="file"
          orientation="vertical"
          name="patient_consent_obj"
          @update="setImageId"
          @image="setImageSrc"
        )
        //- accepted-type="image_pdf_doc"
</template>

<script>
import {
  ResultPatientConsentCreate,
  EquipmentResultPatientConsentCreate,
} from '@api/store.service'

export default {
  ResultPatientConsentCreate,
  EquipmentResultPatientConsentCreate,

  props: ['form', 'isEquipment'],

  data() {
    return {
      loaderTitles: {
        create: this._('Загрузить Документ'),
        update: this._('Изменить Документ'),
      },
    }
  },

  methods: {
    setImageId(imageId) {
      this.form.patient_consent_obj = imageId
    },

    setImageSrc(val) {
      this.form.localFiles.patient_consent_obj = val

      this.$emit('upload')
    },
  },
}
</script>
